
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Icon, Menu} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";

export default class Duration extends BaseComponent {
    static defaultProps = {configName:"picture"};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            duration:'时长不限',
            durationList:{
                video:[],
                audio:[],
            },
            configNameList: {
                videoDuration: 'video',
                audioDuration: 'audio',
            },
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDurationList()
    }

    render() {
        let {configName} = this.props;
        let durationList = this.state.durationList;
        let durationItem =durationList[configName];
        let duration = (
            <Menu style={{marginTop:'7px'}} onClick={({item, key,}) => {
                this.selectMenu(key)
                this.newDuration(key)
            }}>
                {
                    durationItem && durationItem.map(optionName =>
                        <Menu.Item style={{background: this.state.duration === optionName.key ? "#e6f7ff" : ""}} value={optionName.key} key={optionName.value || optionName.key}>{optionName.key}</Menu.Item>
                    )
                }
            </Menu>
        )
        return (
            <Dropdown overlay={duration} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {this.state.duration}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }
    newDuration(key){
        if (key) {
            if (key == "0-60000") {
                this.state.duration = "0-1分钟"
            } else if (key == "60000-600000") {
                this.state.duration = "1-10分钟"
            }else if (key == "600000-") {
                this.state.duration = "10分钟以上"
            }
        }
    }


    selectMenu(data) {
        this.state.duration = data;
        this.setState({});
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:'duration', data}])
        }
    };

    getDurationList =()=>{
        let {configName} = this.props;
        let {configNameList} = this.state;
        let optionsNames = "videoDuration";
        for(let i in configNameList) {
            if(configNameList[i] === configName) {
                optionsNames = i;
                break
            }
        }
        // if ( !(optionsNames && configNameList[optionsNames] && this.state.durationList[configNameList[optionsNames]] && this.state.durationList[configNameList[optionsNames]].length)){
            this.request({
                url: `/search-server/search/getListFromConfig?optionsNames=${optionsNames}`,
                method: "get",
                contentType: 'json',
                callBack: (res) => {
                    if(res && res[optionsNames]){
                        this.state.durationList[configNameList[optionsNames]] = res[optionsNames];
                    }
                    this.setState({})
                }
            })
        // }

    }
}